import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '1',
  title: 'Identifica',
  desc: 'Descubre 3 mini-negocios digitales actuales y fáciles de ofrecer'
}, {
  number: '2',
  title: 'Prepárate',
  desc: 'Aprende a presentar tus servicios con confianza'
}, {
  number: '3',
  title: 'Empieza',
  desc: 'Da tus primeros pasos para conseguir clientes'
}];
export function SolutionSection() {
  return <section className="bg-navy text-white py-16 md:py-24" data-id="element-131">
      <div className="max-w-6xl mx-auto px-4" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-133">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-134">
            Conoce el Método <span className="text-gold" data-id="element-135">IA Exprés 2026</span>
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-136">
            Una estructura clara y práctica para ayudarte a identificar
            servicios digitales vendibles, presentarlos con seguridad y dar tus
            primeros pasos hacia algo propio usando solo tu celular.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-137">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-gold/20 z-0" data-id="element-138" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-139">
              <div className="w-24 h-24 rounded-full bg-navy-dark border-2 border-gold flex items-center justify-center text-4xl font-bold text-gold mb-6 shadow-[0_0_30px_rgba(212,168,83,0.2)]" data-id="element-140">
                {step.number}
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-141">{step.title}</h3>
              <p className="text-gray-400 text-lg" data-id="element-142">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}